import React from "react";

import { StyledButton } from "./styles/Btn";

const Btn = (
  {
    displayNone = false,
    label = "",
    bgcolor = "primary",
    hovercolor = "orange",
    textcolor = "white",
    startIcon,
    disabled = false,
    full,
    onClick,
    sameWidth = false,
    endIcon,
    style = {},
    height,
    fontSize = "",
    ...props
  },
  ref
) => {
  return (
    <StyledButton
      {...props}
      height={height}
      variant="contained"
      startIcon={startIcon}
      bgcolor={bgcolor}
      hovercolor={hovercolor}
      textcolor={textcolor}
      full={full}
      disabled={disabled}
      onClick={onClick}
      $sameWidth={sameWidth}
      endIcon={endIcon}
      style={style}
      fontSize={fontSize}
      $displayNone={displayNone}
      ref={ref}
    >
      {label}
    </StyledButton>
  );
};

export default React.forwardRef(Btn);
